var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4143 14.8638H8.83399C5.63459 14.8638 3.04102 17.4573 3.04102 20.6567V31.328C3.04102 34.5274 5.63459 37.121 8.83399 37.121H19.8102V41.3895L24.0787 37.121H29.4143C32.6137 37.121 35.2073 34.5274 35.2073 31.328V20.6567C35.2073 17.4573 32.6137 14.8638 29.4143 14.8638Z",
    fill: "url(#paint0_linear_1455_20573)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0343 27.8226C13.9605 27.8226 14.7112 27.0718 14.7112 26.1457C14.7112 25.2195 13.9605 24.4688 13.0343 24.4688C12.1082 24.4688 11.3574 25.2195 11.3574 26.1457C11.3574 27.0718 12.1082 27.8226 13.0343 27.8226Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.132 27.8226C20.0581 27.8226 20.8089 27.0718 20.8089 26.1457C20.8089 25.2195 20.0581 24.4688 19.132 24.4688C18.2059 24.4688 17.4551 25.2195 17.4551 26.1457C17.4551 27.0718 18.2059 27.8226 19.132 27.8226Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2296 27.8226C26.1558 27.8226 26.9066 27.0718 26.9066 26.1457C26.9066 25.2195 26.1558 24.4688 25.2296 24.4688C24.3035 24.4688 23.5527 25.2195 23.5527 26.1457C23.5527 27.0718 24.3035 27.8226 25.2296 27.8226Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4199 6.7569V13.027C20.4199 19.362 24.5194 24.9767 30.4814 26.9465C36.4434 24.9767 40.5429 19.362 40.5429 13.027V6.7569C37.05 6.42914 33.6337 5.50737 30.4814 4.03809C27.3291 5.50744 23.9129 6.42914 20.4199 6.7569Z",
    fill: "url(#paint1_linear_1455_20573)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1914 11.7231V12.567C27.1914 12.988 27.5327 13.3292 27.9536 13.3292C28.3745 13.3292 28.7159 12.988 28.7159 12.567V11.7231C28.7159 10.7475 29.5097 9.95367 30.4853 9.95367C31.461 9.95367 32.2548 10.7475 32.2548 11.7231V12.567C32.2548 12.988 32.5961 13.3292 33.017 13.3292C33.4379 13.3292 33.7792 12.988 33.7792 12.567V11.7231C33.7792 9.90679 32.3016 8.4292 30.4853 8.4292C28.6691 8.4292 27.1914 9.90687 27.1914 11.7231Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8573 12.5669H27.1061C26.3604 12.5669 25.7559 13.1714 25.7559 13.9171V19.3181C25.7559 20.0638 26.3604 20.6683 27.1061 20.6683H33.8573C34.603 20.6683 35.2075 20.0638 35.2075 19.3181V13.9171C35.2075 13.1714 34.603 12.5669 33.8573 12.5669Z",
    fill: "url(#paint2_linear_1455_20573)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7126 16.0287C31.7126 15.3551 31.1665 14.8091 30.493 14.8091C29.8195 14.8091 29.2734 15.3551 29.2734 16.0287C29.2734 16.3771 29.4203 16.6905 29.6546 16.9128V18.4266H31.3315V16.9128C31.5657 16.6905 31.7126 16.3771 31.7126 16.0287Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_20573",
    x1: 6.36293,
    y1: 15.9065,
    x2: 32.2292,
    y2: 36.7811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C96C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_20573",
    x1: 30.4814,
    y1: 4.03809,
    x2: 30.4814,
    y2: 26.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DC127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06DE90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1455_20573",
    x1: 25.8764,
    y1: 13.1838,
    x2: 34.4985,
    y2: 19.9907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6842D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon11);
export default __webpack_public_path__ + "static/media/message_card_icon11.2652872a417e9e8c4e6e3f86dcb3f2ac.svg";
export { ForwardRef as ReactComponent };